












































import {Component, Vue, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import Alert from '@/components/UI/Alert.vue';


const dialog = namespace('dialog')
const forms = namespace('forms')
const workspace = namespace('workspace')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    Alert,
  },
  name: "AddQuestionForm"
})
export default class ShowScanProducts extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any
  @forms.Getter('options') protected options:any
  @workspace.Getter('getPlan') protected plan: any
  
  
  get headers() {
    return [
      {
        text: this.$t("newstatistics.visitor_badges_scanned.contact"),
        value: 'name'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.phone"),
        value: 'phone'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.e-mail"),
        value: 'email'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.city"),
        value: 'city'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.company"),
        value: 'companyTitle'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.position"),
        value: 'position'
      },
    ]
  }

  get items() {
    return this.plan == 'free' ? this.options.items.slice(0, 3) : this.options.items
  }

  close() {
    this.SetFullDialogShow(false)
  }

  showPlans() {
    this.SetFullPlanShow(true)
  }
}
